import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react';
import CartProducts from '../../CartProducts';
import Swal from 'sweetalert2';
import { Link } from 'react-router-dom';
import { Cartcontext } from '../Cartcontext';
export default function Cart() {
  const [cartId, setcartID] = useState()
  const { setcart: ContextSetCart } = useContext(Cartcontext)
  const [Isloading, setIsloading] = useState(false)
  const [cart, setcart] = useState({})
  function RemoveProduct(productId) {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!"
    }).then(async (result) => {
      if (result.isConfirmed) {
        const { data } = await axios.delete('https://ecommerce.routemisr.com/api/v1/cart/' + productId, { headers: { token: localStorage.getItem('token') } })
        setcart(data)
        ContextSetCart(data)
        Swal.fire({
          title: "Deleted!",
          text: "Your file has been deleted.",
          icon: "success"
        });
      }
    });

    // console.log(data)
  }
  async function ClearCart() {
    setIsloading(false)
    const { data } = await axios.delete('https://ecommerce.routemisr.com/api/v1/cart', { headers: { token: localStorage.getItem('token') } })
    setcart(data)
    ContextSetCart({})

    // console.log(data)
  }
  async function GetLoggedUserCart() {
    try {
      setIsloading(true)
      const { data } = await axios.get('https://ecommerce.routemisr.com/api/v1/cart', {
        headers: {
          token: localStorage.getItem('token')
        }
      }

      )
      console.log(data)
      setcartID(data.data._id)
      setcart(data)
      setIsloading(false)

    } catch (error) {
      console.log(error)
    }
  }


  async function UpdateCount(productId, count) {
    if (count == 0) {
      RemoveProduct(productId)
    } else {
      const { data } = await axios.put('https://ecommerce.routemisr.com/api/v1/cart/' + productId, { count }, { headers: { token: localStorage.getItem('token') } })
      setcart(data)
      console.log(data)
    }
  }
  useEffect(() => {
    GetLoggedUserCart()
  }, [])
  return <>
    <div className="container">
      {Isloading ?
        <div className='d-flex align-items-center justify-content-center my-5 py-5 text-center loader-row '>
          <div className="col-auto">
            <div className="preloader">
              <svg className="cart" role="img" aria-label="Shopping cart line animation" viewBox="0 0 128 128" width="128px" height="128px" xmlns="http://www.w3.org/2000/svg">
                <g fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="8">
                  <g className="cart__track" stroke="hsla(0,10%,10%,0.1)">
                    <polyline points="4,4 21,4 26,22 124,22 112,64 35,64 39,80 106,80" />
                    <circle cx="43" cy="111" r="13" />
                    <circle cx="102" cy="111" r="13" />
                  </g>
                  <g className="cart__lines" stroke="currentColor">
                    <polyline className="cart__top" points="4,4 21,4 26,22 124,22 112,64 35,64 39,80 106,80" stroke-dasharray="338 338" stroke-dashoffset="-338" />
                    <g className="cart__wheel1" transform="rotate(-90,43,111)">
                      <circle className="cart__wheel-stroke" cx="43" cy="111" r="13" stroke-dasharray="81.68 81.68" stroke-dashoffset="81.68" />
                    </g>
                    <g className="cart__wheel2" transform="rotate(90,102,111)">
                      <circle className="cart__wheel-stroke" cx="102" cy="111" r="13" stroke-dasharray="81.68 81.68" stroke-dashoffset="81.68" />
                    </g>
                  </g>
                </g>
              </svg>
            </div>

          </div>
        </div> :
        <div>
          {cart.data?.products.length == 0 || cart.data?.products.length == undefined ? <h2 className='alert alert-warning text-center my-5'>No products in your cart</h2> :
            <div className='my-5'>
              <div className="row  justify-content-between">
               
                <div className="col-auto">              <Link to={'/address/' + cartId} className='btn bg-main text-white'>CheckOut</Link>
                </div>
                <div className="col-auto">            <button className='btn btn-outline-danger d-block ms-auto' onClick={ClearCart}>Clear Cart</button>
                </div>
              </div>
              {cart.data?.products.map((cartproduct, index) => {
                return <>
                  <CartProducts key={index} cartproduct={cartproduct} RemoveProduct={RemoveProduct} UpdateCount={UpdateCount} />

                </>

              })}

              <div className='d-flex justify-content-center'>
                <p className='total-price'>Total cart Price: {cart.data?.totalCartPrice} EGP</p>
              </div>

            </div>
          }
        </div>}

    </div>


  </>
}
